import CarouselImagePreviewSquare from '@/experiments/single-step-buy-stack/CarouselImagePreviewSquare';
import {logInfo} from '@/utilities/log';
import Slider from '@ant-design/react-slick';
import {useState} from 'preact/hooks';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export type GwpImageCarouselProps = {
  imageUrls: string[];
};

/**
 * Renders a carousel component for displaying images.
 * @param imageUrls - An array of image URLs to display in the carousel.
 */
export default function GwpImageCarousel({imageUrls}: GwpImageCarouselProps) {
  const [active, setActive] = useState(0);
  const mainImage = imageUrls[active];

  return (
    <Slider
      className="slotted__content"
      dots={true}
      dotsClass=""
      fade={true}
      arrows={false}
      easing="ease-in-out"
      infinite={true}
      speed={200}
      appendDots={(dots) => (
        <div className="mt-3 w-full overflow-x-auto">
          <div className="flex list-none justify-center gap-x-3 md:mt-0">
            {dots}
          </div>
        </div>
      )}
      beforeChange={(_, newIndex) => {
        logInfo('ChangeCarouselImage', {
          index: newIndex,
          url: imageUrls[newIndex],
        });
        setActive(newIndex);
      }}
      customPaging={(i) => (
        <CarouselImagePreviewSquare
          image={{url: imageUrls[i], alt: ''}}
          isActive={i === active}
          onClick={() =>
            logInfo('ClickCarouselPreviewImage', {index: i, url: imageUrls[i]})
          }
        />
      )}
    >
      {imageUrls.map((image) => (
        <img
          key={image}
          src={mainImage}
          alt="Earth Breeze products"
          className="pointer-events-none aspect-[3/2] w-full object-contain object-top md:aspect-[4/5] md:max-h-unset md:object-contain md:object-top"
        />
      ))}
    </Slider>
  );
}
